// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DDkP","name":"styles_name__2KWkd","phone":"styles_phone__2GE22"};